import styled from "styled-components";

export const EmptyImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 40%;
  border: 1px solid #efefef;
  border-radius: 6px;
`;
